import React from "react";
import { Link } from "react-router-dom";
import { Activity } from "lucide-react";
import { NAV } from "../data/content";

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-dark border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Link to="/" className="flex items-center gap-2.5 mb-5">
            <span className="grid place-items-center w-9 h-9 bg-orange text-white">
              <Activity className="w-5 h-5" strokeWidth={2.5} />
            </span>
            <span className="font-display font-extrabold text-lg tracking-tight">
              ATHLETIC<span className="text-teal">DATA</span>
            </span>
          </Link>
          <p className="text-slate-400 max-w-sm leading-relaxed">
            Custom sports data applications that collect, organize, and display athletic data in fully
            searchable, structured, and intuitive formats.
          </p>
        </div>

        <div className="md:col-span-3 md:col-start-8">
          <h4 className="font-mono text-xs uppercase tracking-widest text-teal mb-5">Explore</h4>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-slate-300 hover:text-white transition-colors">{n.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-mono text-xs uppercase tracking-widest text-teal mb-5">Contact</h4>
          <ul className="space-y-3 text-slate-300">
            <li>info@athleticdatasolutions.com</li>
            <li>Mon–Fri, 9–6 ET</li>
            <li><Link to="/admin/login" data-testid="footer-admin-link" className="text-slate-500 hover:text-teal">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-500 font-mono uppercase tracking-widest">
          <span>© {new Date().getFullYear()} Athletic Data Solutions</span>
          <span>Built for the people on the field</span>
        </div>
      </div>
    </footer>
  );
};
